import { API, MapBoxAPI } from 'api';
import { ENV } from 'shared/ENV';
import { MapSearchApi, WithStringDates } from 'shared/types';
import { MapSearchResult } from 'hooks/useMapSearch/useMapSearch.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { fetchGoogleMapsSearch } from 'hooks/useMapSearch';
import { parseGeoEventDates } from 'features/geoEvents/geoEvent.utils';

/** @deprecated by `fetchMapboxSearch()` in `useMapSearch()` */
export const fetchLocations = async (
  term: string,
  proximity: string,
  searchApi: MapSearchApi,
): Promise<MapSearchResult[]> => {
  if (searchApi === 'google') {
    return fetchGoogleMapsSearch(term, proximity);
  }

  const res = await MapBoxAPI.get<{
    type: 'FeatureCollection';
    query: string[];
    features: MapSearchResult[];
  }>(`/${encodeURIComponent(term)}.json`, {
    params: {
      access_token: ENV.VITE_MAPBOX_ACCESS_TOKEN ?? '',
      proximity,
      types:
        'country,region,district,postcode,locality,place,address,poi,neighborhood',
      language: 'en',
      limit: '5',
      country: 'us',
    },
  });

  return res.data.features;
};

/** @deprecated by `fetchGeoEventsForSearch()` in `useMapSearch()` */
export const fetchGeoEvents = async (term: string): Promise<Wildfire[]> => {
  const params = new URLSearchParams({
    q: term,
    limit: '10',
    reporter_managed_only: 'false',
  });
  const res = await API.get<{ results: WithStringDates<Wildfire>[] }>(
    `geo_events/search?${params.toString()}`,
  );
  return res.data.results.map((geoEvent) => parseGeoEventDates(geoEvent));
};
